




























































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
@Component({
  components: {
    SideBar
  }
})
export default class Index extends Vue {
  nav = [];
  list = [
    {
      title: "社会变化加剧，唯有更快才能适应",
      tips: "Only faster can we adapt to the aggravation of social changes",
      desc:
        "信息技术的发展推动社会加速变化，需要适应数字化时代的知识更新要求，加快有效学习",
      src: "background-image: url(" + require("../../../assets/pic35.png") + ")"
    },

    {
      title: "社会变化加剧，唯有更快才能适应",
      tips: "Only faster can we adapt to the aggravation of social changes",
      desc:
        "信息技术的发展推动社会加速变化，需要适应数字化时代的知识更新要求，加快有效学习",
      src: "background-image: url(" + require("../../../assets/pic36.png") + ")"
    },
    {
      title: "数字化人才存在巨大需求",
      tips: "Only faster can we adapt to the aggravation of social changes",
      desc:
        "预计2025年数字化相关岗位将达3.5亿，数字化人才培养需要通过社会培训力量弥补海量需求",
      src: "background-image: url(" + require("../../../assets/pic37.png") + ")"
    },
    {
      title: "培训工作对抗职业衰老",
      tips: "Only faster can we adapt to the aggravation of social changes",
      desc:
        "确定性工作将逐步被机器取代；而培训是面向不确定性的工作，有良好的抗职业衰老特性",
      src: "background-image: url(" + require("../../../assets/pic38.png") + ")"
    },
    {
      title: "我们希望找到这样的你！",
      tips: "Only faster can we adapt to the aggravation of social changes",
      desc: "乐于分享，志存高远 持续学习，奋斗抗压 专注专业，开放创新",
      src: "background-image: url(" + require("../../../assets/pic39.png") + ")"
    }
  ];
}
